import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { installmentsListAction } from "../../../redux/actions/studentActions";
import PaymentDetails from "../../PaymentsLIst/PaymentDetails";
import AgGridTable from "../../Tables/agGridTable";
import { PAYMENT_COMPLETED ,PAYMENT_FAILED,INITIATE_PAYMENT,SETTLE_STUDENT,PAYMENT_PENDING,PARTIAL_PAYMENT} from "../../../components/constants";


const StudentHistory = (props) => {
  const dispatch = useDispatch();
  const { loader ,studentHistoryData,installmentsData  } = useSelector((state) => state.student);
  const [show, setShow] = useState(false);
  const [selectedStudentFee, setSelectedStudentFee] = useState({})
  const installmentsDetails = async(data)=>{
    await dispatch(installmentsListAction({
      StudentFeeId: data.StudentFeeId
    }))
    setSelectedStudentFee(data);
    setShow(true)
  }

  const actionsListComponent = props => {
    console.log(props)
    return (
      <>
          {
            props.data ? (
              <>
              <span>
            <i class={"fa fa-angle-right"}  aria-hidden="true" title="Payment Details" style={{
          alignItems: "center",
          color: "#1c5983",
          cursor: 'pointer',
          fontSize:"18px"
          
        }} onClick={()=>{
          props.installmentsDetails(props.data);
        }}></i> 
        </span>
        </>
        ) : null }
          
         
        
      </>
    )  
  };

  const headerList = [
    { headerName: "Year", field: "year",maxWidth:100 },
    {
      headerName: "Regd No",
      field: "RegNo",
      maxWidth:100
    },
    { headerName: "Class Group", field: "ClassGroupName",maxWidth:150 },
    { headerName: "Class Room", field: "ClassRoomName",maxWidth:150 },
    { headerName: "Start Date", field: "academicStartDate",maxWidth:150 },
    { headerName: "End Date", field: "academicEndDate",maxWidth:150 },
    { headerName: "Course Fee", field: "courseAmount",maxWidth:150 } , 
    { headerName: "Other Fee", field: "otherAmount",maxWidth:100 } , 
    { headerName: "Paid", field: "paidAmount",maxWidth:100 } , 
    { headerName: "Discount", field: "discount",maxWidth:100 } ,  
    { headerName: "Due Amount", field: "dueAmount" ,maxWidth:150} , 
    { headerName: "Discount Type", field: "discountType", }, 
    { headerName: "Ref Name", field: "refName", }, 
    { headerName: "Student Fee Status", field: "studentFeeStatus", 
    cellStyle: params => {
      if (params.value === PAYMENT_COMPLETED) {
          return { backgroundColor: '#ddeec4'};
      }
      if (params.value === PARTIAL_PAYMENT) {
        return { backgroundColor: '#f3c0bf'};
      }
      // if (params.value === PAYMENT_FAILED) {
      //   return { backgroundColor: '#fddfbd'};
      // }
      // if (params.value === INITIATE_PAYMENT) {
      //   return { backgroundColor: '#fddfbd'};
      // }
      if (params.value === SETTLE_STUDENT) {
        return { backgroundColor: '#fddfbd'};
      }
      

      return null;
  }},
    { headerName: "Date Of Join", field: "createdAt",maxWidth:250 },
    
    {
      headerName: "Action",
      field: "action",
      maxWidth:100,
      cellRenderer: "actionsListComponent",
      cellRendererParams: {
        installmentsDetails,
      },
    },
  ];

  const installmentsHeaders = [
    { headerName: "Amount", field: "amount",maxWidth:170 },
    { headerName: "Other Amount", field: "otherAmount",maxWidth:150 },
    {
      headerName: "Paid Amount",
      field: "paidAmount",
    },
    // { headerName: "Admission Fee", field: "admissionFee" },
    { headerName: "Discount", field: "discount",maxWidth:150 },
    { headerName: "Payment Due", field: "dueAmount" },
    { headerName: "Created At", field: "createdAt" },

  ];
  const closeModal =()=>{
    setShow(false)
  }
  return (
    <div className="page-wrapper">
          <div className="spacer"></div>
          { show  && installmentsData.length > 0 ?  (
            <PaymentDetails show={show} data={{
              tableHeaders : installmentsHeaders,
              tableData: installmentsData,
              nestedHeaders : []
            }} closeModal={closeModal}/>
          ) : null }
          {studentHistoryData.length > 0 ? (
            <>
            {/* <DataTable
              header={headerList}
              data={studentHistoryData}
              // nestedHeader={nestedHeaders}
            /> */}
            <AgGridTable 
            rowData={studentHistoryData} 
            columnDefs={headerList} 
            defaultColDef={{
              resizable: true,minWidth: 100}}
              frameworkComponents={{
                actionsListComponent
            }}
              />
              </>
          ) : (
            <div className="alert alert-success">No Data to view</div>
          )}
       
    </div>
  );
};

export default StudentHistory;
